export const PROJECT_EMAIL_LOCAL_API_REQUESTS = false;
